import { createI18n } from 'vue-i18n';
import fr from '@/locales/fr.json';

/**
 * Le back-office n'est utilisé que par l'exploitation monégasque : une seule
 * langue, pas de sélecteur. Le mécanisme reste en place pour permettre d'en
 * ajouter une sans refonte.
 */
export default createI18n({
	legacy: false,
	globalInjection: true,
	locale: 'fr',
	fallbackLocale: 'fr',
	messages: { fr },
});
